export default __webpack_public_path__ + "static/fixfiled-607549f60eb595687f8953eb6b80740b.png";